import cart, { getCartBasePath } from './cart.js';

const IN_CART_HTML = '<a href="#">Produktet er lagt i kurven</a>';

class SubscriptionGuard {
  constructor() {
    this._intercept();
    this._bindInCartClick();
    document.addEventListener('DOMContentLoaded', () => this.updateUI());
  }

  async enforce() {
    const data = await cart.get();
    if (!data?.items) return;

    const subsByProduct = new Map();

    for (const item of data.items) {
      if (!cart.isSubscription(item)) continue;
      if (!subsByProduct.has(item.product_id)) {
        subsByProduct.set(item.product_id, []);
      }
      subsByProduct.get(item.product_id).push(item);
    }

    let changed = false;

    // /cart.js lists items most-recently-added first, so keeping items[0]
    // means a newly added cadence replaces the product's previous subscription.
    for (const [, items] of subsByProduct) {
      for (let i = 1; i < items.length; i++) {
        await cart.changeItem(items[i].key, 0);
        changed = true;
      }

      if (items[0].quantity > 1) {
        await cart.changeItem(items[0].key, 1);
        changed = true;
      }
    }

    if (changed) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    await this.updateUI();
  }

  async updateUI() {
    const data = await cart.get();
    if (!data?.items) return;

    const subsInCart = new Set();
    for (const item of data.items) {
      if (cart.isSubscription(item)) {
        subsInCart.add(String(item.variant_id));
      }
    }

    this._updateBuyBox(subsInCart);
    this._updateDirectButtons(subsInCart);
  }

  _updateBuyBox(subsInCart) {
    document.querySelectorAll('.buy-box-cta-subscription').forEach(wrapper => {
      const btn = wrapper.querySelector('.subscription-atc-button');
      if (!btn) return;

      const variantId = btn.getAttribute('variant_id');
      const inCart = subsInCart.has(variantId);

      btn.classList.toggle('d-none', inCart);

      let badge = wrapper.querySelector('.product-in-cart-btn');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'product-in-cart-btn d-none';
        badge.innerHTML = IN_CART_HTML;
        btn.insertAdjacentElement('afterend', badge);
      }
      badge.classList.toggle('d-none', !inCart);
    });
  }

  _updateDirectButtons(subsInCart) {
    document.querySelectorAll('.cm-direct-add-btn').forEach(btn => {
      const variantId = btn.getAttribute('data-cm-add-variant');
      if (!variantId) return;

      const inCart = subsInCart.has(variantId);

      btn.classList.toggle('d-none', inCart);

      let badge = btn.nextElementSibling;
      if (!badge?.classList.contains('product-in-cart-btn')) {
        badge = document.createElement('div');
        badge.className = 'product-in-cart-btn d-none';
        badge.innerHTML = IN_CART_HTML;
        btn.insertAdjacentElement('afterend', badge);
      }
      badge.classList.toggle('d-none', !inCart);
    });
  }


  _bindInCartClick() {
    document.addEventListener('click', (e) => {
      const badge = e.target.closest('.product-in-cart-btn');
      if (!badge) return;
      e.preventDefault();
      cart.openDrawer();
    });
  }

  _intercept() {
    const guard = this;

    window.fetch = async function (url, options) {
      const urlStr = (typeof url === 'string' ? url : url?.url) || '';
      const isCartMutation =
        urlStr.includes(getCartBasePath('add')) ||
        urlStr.includes(getCartBasePath('change')) ||
        urlStr.includes(getCartBasePath('update'));

      if (!isCartMutation) {
        return cart.fetch.apply(this, arguments);
      }

      const response = await cart.fetch.apply(this, arguments);

      if (response.ok) {
        try { await guard.enforce(); } catch (e) {
          console.warn('[subscription-guard]', e);
        }
      }

      return response;
    };
  }
}

if (window.cmSubscriptionGuard) {
  new SubscriptionGuard();
}
